import request from '@/utils/request'

async function mRequest(config) {
  return ((await request({
    ...config,
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
  })).res || {}).data
}

export function getToken() {
  return mRequest({
    url: '/zuul/chatV4/token/get',
    method: 'get',
    headers: {
      "portal-token": true,
    }
  })
}

export function getSingleList() {
  return mRequest({
    url: '/zuul/chatV4/friend/list',
    method: 'get',
    headers: {
      "portal-token": true,
    }
  })
}


export function getGroupList() {
  return mRequest({
    url: '/zuul/chatV4/group/list',
    method: 'get',
    headers: {
      "portal-token": true,
    },
  })
}

export function groupDetail(params) {
  return mRequest({
    url: '/zuul/chatV4/group/detail',
    method: 'get',
    params,
    headers: {
      "portal-token": true,
    }
  })
}

export function createTeam(data) {
  // let _data = {
  //   ...data,
  //   name: `${data.name} (${data.memberList.length+1})`
  // }
  return mRequest({
    url: '/zuul/chatV4/group/create',
    method: 'post',
    data,
    headers: {
      "portal-token": true,
      'Content-Type': 'application/json'
    }
  })
}

export function editGroup(data) {
  return mRequest({
    url: '/zuul/chatV4/group/edit',
    method: 'post',
    data,
    headers: {
      "portal-token": true,
      'Content-Type': 'application/json'
    }
  })
}

export function dissolutionGroup(params) {
  return mRequest({
    url: '/zuul/chatV4/group/dissolution',
    method: 'get',
    params,
    headers: {
      "portal-token": true,
    }
  })
}

export function quitGroup(params) {
  return mRequest({
    url: '/zuul/chatV4/group/quit',
    method: 'get',
    params,
    headers: {
      "portal-token": true,
    }
  })
}

export function groupAddMember(data, params) {
  return mRequest({
    url: '/zuul/chatV4/group/add/member',
    method: 'post',
    params,
    data,
    headers: {
      "portal-token": true,
      'Content-Type': 'application/json'
    }
  })
}

export function groupRemoveMember(data, params) {
  return mRequest({
    url: '/zuul/chatV4/group/remove/member',
    method: 'post',
    params,
    data,
    headers: {
      "portal-token": true,
      'Content-Type': 'application/json'
    }
  })
}
